import { TextSizingType } from './type'

export type Direction = 'horizontal' | 'vertical'

export type Position = 'top' | 'bottom' | 'left' | 'right' | 'alternating'

export type InputType = 'uniselection' | 'multiselection'

export const textSizings: TextSizingType = {
  extraSmall: {
    label: 'label-required-01',
    optionLabel: 'content-02'
  },
  small: {
    label: 'label-required-02',
    optionLabel: 'content-03'
  },
  semiSmall: {
    label: 'label-required-03',
    optionLabel: 'content-04'
  },
  regular: {
    label: 'label-required-04',
    optionLabel: 'content-05'
  },
  semiLarge: {
    label: 'label-required-05',
    optionLabel: 'content-06'
  },
  large: {
    label: 'label-required-06',
    optionLabel: 'content-07'
  },
  extraLarge: {
    label: 'label-required-07',
    optionLabel: 'content-08'
  },
  semiGiant: {
    label: 'label-required-08',
    optionLabel: 'content-08'
  }
}
